<template>
  <div class="sizeButtonContainer" :class="{isShow: !isKeySelected}">
    <div
      class="sizeButton sizeButton--1"
      :class="{ sizeButtonSelected: isSelectedSize(1) }"
      @click="changeSize(1)"
    >
      <div class="sizeButton__button"><span>細</span></div>
      <div class="sizeButton__image sizeButton__image--1">
        <div class="sizeButton__spray" v-show="isSpraySelected"></div>
        <div class="sizeButton__marker" v-show="isMarkerSelected"></div>
      </div>
    </div>
    <div
      class="sizeButton sizeButton--2"
      :class="{ sizeButtonSelected: isSelectedSize(2) }"
      @click="changeSize(2)"
    >
      <div class="sizeButton__button"><span>中</span></div>
      <div class="sizeButton__image sizeButton__image--2">
        <div class="sizeButton__spray" v-show="isSpraySelected"></div>
        <div class="sizeButton__marker" v-show="isMarkerSelected"></div>
      </div>
    </div>
    <div
      class="sizeButton sizeButton--3"
      :class="{ sizeButtonSelected: isSelectedSize(3) }"
      @click="changeSize(3)"
    >
      <div class="sizeButton__button"><span>太</span></div>
      <div class="sizeButton__image sizeButton__image--3">
        <div class="sizeButton__spray" v-show="isSpraySelected"></div>
        <div class="sizeButton__marker" v-show="isMarkerSelected"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../store/modules/tool/types";
import * as StoreUtil from "../../util/StoreUtil";

export default {
  name: "SizePalette",
  props: [],
  computed: {
    tool() {
      return this.$store.state.tool;
    },
    isSpraySelected() {
      return StoreUtil.isToolSpray();
    },
    isMarkerSelected() {
      return StoreUtil.isToolMarker();
    },
    isKeySelected() {
      return StoreUtil.isToolText();
    },
    size() {
      return this.tool.size;
    }
  },
  methods: {
    isSelectedSize(index) {
      return this.tool.size == index;
    },
    changeSize(type) {
      this.$store.dispatch(types.namespace + types.SET_SIZE, type);
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/colors"
.sizeButtonContainer
    display: flex
    justify-content: space-between
    height: 0
    opacity: 0
    overflow: hidden
    //transition: all 0.12s cubic-bezier(0.790, -0.010, 0.145, 0.990)
    transition: all 0.12s cubic-bezier(1.000, -0.050, 0.030, 1.005)
    position: relative
    padding-bottom: 0
    margin-bottom: 0
    border-bottom: 2px solid $separator_border
    &.isShow
        overflow: visible
        padding-top: 2px
        padding-bottom: 14px
        margin-bottom: 12px
        height: 48px
        opacity: 1

.sizeButton
    width: 110px
    padding-top: 6px
    position: relative
    top: -5px

    display: flex
    align-items: center
    &.sizeButton--2
        width: 110px
    &.sizeButton--3
        width: 110px
    //border-right: 1px solid $separator_border
    &:after
      content: ""
      position: absolute
      top: -2px
      right: 0px
      width: 2px
      height: 40px
      border-right: 1px solid $separator_border
    padding-right: 10px
    &:last-child
      border-right: none
      padding-right: 0
      &:after
        content: none
        display: none


.sizeButtonSelected
    .sizeButton__button
        border: 2px solid $button_border
    .sizeButton__image
        opacity: 1


.sizeButton__button
    width: 25px
    height: 25px
    border-radius: 25px
    background-color: $button_bg
    border: 2px solid $button_bg
    transition: border-color 0.08s ease-in

    color: white
    display: flex
    justify-content: center
    align-items: center
    font-size: 12px
    margin-right: 4px
.sizeButton__spray, .sizeButton__marker
    display: block
    background-size: 316px*0.5 156px*0.5
    background-image: url("/img/ui/tool/size.png")
.sizeButton__image
    opacity: 0.5
    width: 69px
    transition: opacity ease-in 0.08s
    .sizeButton__marker
      position: relative
      left: 2px
    &.sizeButton__image--3
      .sizeButton__marker
        left: 4px
.sizeButton__image--1
    .sizeButton__spray
        width: 136px*0.5
        height: 34px*0.5
        background-position: -170px*0.5 -54px*0.5
    .sizeButton__marker
        width: 125px*0.5
        height: 16px*0.5
        background-position: -170px*0.5 -96px*0.5
.sizeButton__image--2
    .sizeButton__spray
        width: 145px*0.5
        height: 46px*0.5
        background-position: -4px*0.5 -70px*0.5
    .sizeButton__marker
        width: 127px*0.5
        height: 28px*0.5
        background-position: -4px*0.5 -124px*0.5
.sizeButton__image--3
    .sizeButton__spray
        width: 158px*0.5
        height: 58px*0.5
        background-position: -4px*0.5 -4px*0.5
    .sizeButton__marker
        width: 142px*0.5
        height: 42px*0.5
        background-position: -170px*0.5 -4px*0.5


</style>
